import gql from 'graphql-tag';
import { Mutation, Query, QueryRegistry } from 'core';

export const ADDRESS_FIELDS = gql`
  fragment AddressFields on Address {
    id
    name
    company
    address1
    address2
    zip
    city
    province
    country
    phone
    default
  }
`;

const ADDRESSES = gql`
  ${ADDRESS_FIELDS}
  query QueryAddresses($input: GetAddressesInput!) {
    addresses(input: $input) {
      ...AddressFields
    }
  }
`;

export class AddressesQuery extends Query {
  static conf = {
    GQL: ADDRESSES,
    varNames: ['input'],
    resultPath: 'addresses',
  };
}

QueryRegistry.add('addresses.AddressesQuery', AddressesQuery);

const ADDRESS = gql`
  ${ADDRESS_FIELDS}
  query queryAddress($id: ID!) {
    address(id: $id) {
      ...AddressFields
    }
  }
`;

export class AddressQuery extends Query {
  static conf = {
    GQL: ADDRESS,
    varNames: ['id'],
    resultPath: 'address',
  };
}

const CREATE_ADDRESS = gql`
  ${ADDRESS_FIELDS}
  mutation createAddress($input: CreateAddressInput!) {
    createAddress(input: $input) {
      ...AddressFields
    }
  }
`;

export class CreateAddressMutation extends Mutation {
  static conf = {
    GQL: CREATE_ADDRESS,
    inputName: ['input'],
    resultPath: 'createAddress',
  };
}

const UPDATE_ADDRESS = gql`
  ${ADDRESS_FIELDS}
  mutation updateAddress($input: UpdateAddressInput!) {
    updateAddress(input: $input) {
      ...AddressFields
    }
  }
`;

// Only used for setting the address as 'default'
export class UpdateAddressMutation extends Mutation {
  static conf = {
    GQL: UPDATE_ADDRESS,
    inputName: ['input'],
    resultPath: 'updateAddress',
  };
}

const DELETE_ADDRESS = gql`
  ${ADDRESS_FIELDS}
  mutation deleteAddress($input: DeleteAddressInput!) {
    deleteAddress(input: $input) {
      ...AddressFields
    }
  }
`;

export class DeleteAddressMutation extends Mutation {
  static conf = {
    GQL: DELETE_ADDRESS,
    inputName: ['input'],
    resultPath: 'deleteAddress',
  };
}
